"use strict";

var e = require("@react-pdf-viewer/core");
function n(e) {
  var n = Object.create(null);
  return e && Object.keys(e).forEach(function (t) {
    if ("default" !== t) {
      var l = Object.getOwnPropertyDescriptor(e, t);
      Object.defineProperty(n, t, l.get ? l : {
        enumerable: !0,
        get: function get() {
          return e[t];
        }
      });
    }
  }), n.default = e, Object.freeze(n);
}
var t,
  l = n(require("react")),
  r = function r() {
    return l.createElement(e.Icon, {
      size: 16
    }, l.createElement("path", {
      d: "M11.5 23.499L11.5 14.499"
    }), l.createElement("path", {
      d: "M7.5 18.499L11.5 14.499 15.5 18.499"
    }), l.createElement("path", {
      d: "M11.5 1.499L11.5 10.499"
    }), l.createElement("path", {
      d: "M7.5 6.499L11.5 10.499 15.5 6.499"
    }), l.createElement("path", {
      d: "M20.5 12.499L1.5 12.499"
    }));
  },
  c = function c() {
    return l.createElement(e.Icon, {
      size: 16
    }, l.createElement("path", {
      d: "M0.5 12L23.5 12"
    }), l.createElement("path", {
      d: "M11.5 1L11.5 23"
    }), l.createElement("path", {
      d: "M8.5 4L11.5 1 14.5 4"
    }), l.createElement("path", {
      d: "M20.5 9L23.5 12 20.5 15"
    }), l.createElement("path", {
      d: "M3.5 15L0.5 12 3.5 9"
    }), l.createElement("path", {
      d: "M14.5 20L11.5 23 8.5 20"
    }));
  },
  _u = function u() {
    return _u = Object.assign || function (e) {
      for (var n, t = 1, l = arguments.length; t < l; t++) {
        for (var r in n = arguments[t]) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }
      return e;
    }, _u.apply(this, arguments);
  };
!function (e) {
  e[e.ExitFullScreen = 0] = "ExitFullScreen", e[e.FullScreenChange = 1] = "FullScreenChange", e[e.FullScreenElement = 2] = "FullScreenElement", e[e.FullScreenEnabled = 3] = "FullScreenEnabled", e[e.RequestFullScreen = 4] = "RequestFullScreen";
}(t || (t = {}));
var o = {
    ExitFullScreen: "exitFullscreen",
    FullScreenChange: "fullscreenchange",
    FullScreenElement: "fullscreenElement",
    FullScreenEnabled: "fullscreenEnabled",
    RequestFullScreen: "requestFullscreen"
  },
  i = {
    ExitFullScreen: "webkitExitFullscreen",
    FullScreenChange: "webkitfullscreenchange",
    FullScreenElement: "webkitFullscreenElement",
    FullScreenEnabled: "webkitFullscreenEnabled",
    RequestFullScreen: "webkitRequestFullscreen"
  },
  a = {
    ExitFullScreen: "msExitFullscreen",
    FullScreenChange: "msFullscreenChange",
    FullScreenElement: "msFullscreenElement",
    FullScreenEnabled: "msFullscreenEnabled",
    RequestFullScreen: "msRequestFullscreen"
  },
  s = "undefined" != typeof window,
  f = s && (t.FullScreenEnabled in document && o || i.FullScreenEnabled in document && i || a.FullScreenEnabled in document && a) || o,
  S = function S() {
    return s && f.FullScreenEnabled in document && !0 === document[f.FullScreenEnabled];
  },
  E = function E(e) {
    return s ? e[f.ExitFullScreen]() : Promise.resolve({});
  },
  F = function F() {
    return s ? document[f.FullScreenElement] : null;
  },
  m = {
    left: 0,
    top: 8
  },
  d = function d(n) {
    var t = n.enableShortcuts,
      r = n.onClick,
      u = l.useContext(e.LocalizationContext).l10n,
      o = u && u.fullScreen ? u.fullScreen.enterFullScreen : "Full screen",
      i = t ? e.isMac() ? "Meta+Ctrl+F" : "F11" : "";
    return l.createElement(e.Tooltip, {
      ariaControlsSuffix: "full-screen-enter",
      position: e.Position.BottomCenter,
      target: l.createElement(e.MinimalButton, {
        ariaKeyShortcuts: i,
        ariaLabel: o,
        isDisabled: !S(),
        testId: "full-screen__enter-button",
        onClick: r
      }, l.createElement(c, null)),
      content: function content() {
        return o;
      },
      offset: m
    });
  },
  b = {
    left: 0,
    top: 8
  },
  g = function g(n) {
    var t = n.onClick,
      c = l.useContext(e.LocalizationContext).l10n,
      u = c && c.fullScreen ? c.fullScreen.exitFullScreen : "Exit full screen";
    return l.createElement(e.Tooltip, {
      ariaControlsSuffix: "full-screen-exit",
      position: e.Position.BottomCenter,
      target: l.createElement(e.MinimalButton, {
        ariaKeyShortcuts: "Esc",
        ariaLabel: u,
        testId: "full-screen__exit-button-with-tooltip",
        onClick: t
      }, l.createElement(r, null)),
      content: function content() {
        return u;
      },
      offset: b
    });
  },
  x = function x(e, n, t, r) {
    var c = l.useState(!1),
      u = c[0],
      o = c[1],
      i = l.useRef(n.get("getPagesContainer") ? n.get("getPagesContainer")() : null),
      a = function a() {
        var l = F(),
          c = i.current,
          u = l === e(c);
        n.update("isFullScreen", u), u ? c.classList.add("rpv-full-screen__pages") : c.classList.remove("rpv-full-screen__pages");
        var o = n.get("zoom");
        o && (u ? t(o) : r(o));
      },
      m = function m(e) {
        var n;
        i.current = e(), n = a, s && document.addEventListener(f.FullScreenChange, n);
      },
      d = function d(e) {
        o(e);
      };
    return l.useEffect(function () {
      return n.subscribe("isFullScreen", d), n.subscribe("getPagesContainer", m), function () {
        n.unsubscribe("getPagesContainer", m), n.unsubscribe("isFullScreen", d);
      };
    }, []), {
      enterFullScreen: function enterFullScreen() {
        if (S()) {
          var n = i.current;
          n && function () {
            var n = i.current;
            if (!n) return Promise.resolve();
            var t = F();
            return t && t !== e(n) ? E(t) : Promise.resolve();
          }().then(function () {
            var t;
            t = e(n), s && t[f.RequestFullScreen]();
          });
        }
      },
      exitFullScreen: function exitFullScreen() {
        o(!1);
        var t = n.get("getPagesContainer");
        if (t) {
          var l = t();
          if (l) {
            var r = F();
            r && r === e(l) && E(document);
          }
        }
      },
      isFullScreen: u
    };
  },
  v = function v(e) {
    var n = e.children,
      t = e.enableShortcuts,
      r = e.getFullScreenTarget,
      c = e.store,
      u = e.onEnterFullScreen,
      o = e.onExitFullScreen,
      i = x(r, c, u, o),
      a = i.enterFullScreen,
      s = i.exitFullScreen,
      f = i.isFullScreen;
    return (n || function (e) {
      return f ? l.createElement(g, {
        onClick: e.onClick
      }) : l.createElement(d, {
        enableShortcuts: t,
        onClick: e.onClick
      });
    })({
      onClick: f ? s : a
    });
  },
  C = function C(n) {
    var t = n.onClick,
      r = l.useContext(e.LocalizationContext).l10n,
      u = r && r.fullScreen ? r.fullScreen.enterFullScreen : "Full screen";
    return l.createElement(e.MenuItem, {
      icon: l.createElement(c, null),
      isDisabled: !S(),
      testId: "full-screen__enter-menu",
      onClick: t
    }, u);
  },
  h = function h(n) {
    var t = n.onClick,
      c = l.useContext(e.LocalizationContext).l10n,
      u = l.useContext(e.ThemeContext).direction === e.TextDirection.RightToLeft,
      o = c && c.fullScreen ? c.fullScreen.exitFullScreen : "Exit full screen";
    return l.createElement("div", {
      className: e.classNames({
        "rpv-full-screen__exit-button": !0,
        "rpv-full-screen__exit-button--ltr": !u,
        "rpv-full-screen__exit-button--rtl": u
      })
    }, l.createElement(e.MinimalButton, {
      ariaLabel: o,
      testId: "full-screen__exit-button",
      onClick: t
    }, l.createElement(r, null)));
  },
  p = function p(e) {
    var n = e.children,
      t = e.getFullScreenTarget,
      r = e.store,
      c = e.onEnterFullScreen,
      u = e.onExitFullScreen,
      o = x(t, r, c, u),
      i = o.enterFullScreen,
      a = o.exitFullScreen,
      s = o.isFullScreen;
    return s && (n || function (e) {
      return l.createElement(h, {
        onClick: e.onClick
      });
    })({
      onClick: s ? a : i
    });
  },
  k = function k(n) {
    var t = n.containerRef,
      r = n.getFullScreenTarget,
      c = n.store,
      u = n.onEnterFullScreen,
      o = n.onExitFullScreen,
      i = x(r, c, u, o).enterFullScreen,
      a = function a(n) {
        if (!n.shiftKey && !n.altKey && (e.isMac() ? n.metaKey && n.ctrlKey && "f" === n.key : "F11" === n.key)) {
          var l = t.current;
          l && document.activeElement && l.contains(document.activeElement) && (n.preventDefault(), i());
        }
      };
    return l.useEffect(function () {
      if (t.current) return document.addEventListener("keydown", a), function () {
        document.removeEventListener("keydown", a);
      };
    }, [t.current]), l.createElement(l.Fragment, null);
  };
exports.ExitFullScreenIcon = r, exports.FullScreenIcon = c, exports.fullScreenPlugin = function (n) {
  var t = (null == n ? void 0 : n.getFullScreenTarget) || function (e) {
      return e;
    },
    r = l.useMemo(function () {
      return Object.assign({}, {
        enableShortcuts: !0,
        onEnterFullScreen: function onEnterFullScreen() {},
        onExitFullScreen: function onExitFullScreen() {}
      }, n);
    }, []),
    c = l.useMemo(function () {
      return e.createStore({});
    }, []),
    o = function o(e) {
      return l.createElement(v, _u({}, e, {
        enableShortcuts: r.enableShortcuts,
        getFullScreenTarget: t,
        store: c,
        onEnterFullScreen: r.onEnterFullScreen,
        onExitFullScreen: r.onExitFullScreen
      }));
    },
    i = function i() {
      return l.createElement(p, {
        getFullScreenTarget: t,
        store: c,
        onEnterFullScreen: r.onEnterFullScreen,
        onExitFullScreen: r.onExitFullScreen
      }, null == n ? void 0 : n.renderExitFullScreenButton);
    };
  return {
    install: function install(e) {
      c.update("getPagesContainer", e.getPagesContainer), c.update("zoom", e.zoom);
    },
    renderViewer: function renderViewer(e) {
      var n = e.slot;
      return n.subSlot && (n.subSlot.children = l.createElement(l.Fragment, null, r.enableShortcuts && l.createElement(k, {
        containerRef: e.containerRef,
        getFullScreenTarget: t,
        store: c,
        onEnterFullScreen: r.onEnterFullScreen,
        onExitFullScreen: r.onExitFullScreen
      }), l.createElement(i, null), n.subSlot.children)), n;
    },
    EnterFullScreen: o,
    EnterFullScreenButton: function EnterFullScreenButton() {
      return l.createElement(o, null, function (e) {
        return l.createElement(d, _u({
          enableShortcuts: r.enableShortcuts
        }, e));
      });
    },
    EnterFullScreenMenuItem: function EnterFullScreenMenuItem(e) {
      return l.createElement(o, null, function (n) {
        return l.createElement(C, {
          onClick: function onClick() {
            n.onClick(), e.onClick();
          }
        });
      });
    }
  };
};